import firebase from 'firebase/app'
import 'firebase/auth'

var firebaseConfig = {
    apiKey: "AIzaSyAIYeJFDAWN67osxcC7n7LMYsnOuUnEglM",
    authDomain: "auth-news-app.firebaseapp.com",
    projectId: "auth-news-app",
    storageBucket: "auth-news-app.appspot.com",
    messagingSenderId: "718622952115",
    appId: "1:718622952115:web:16f54a988164d8271f3ec6"
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth()

export { auth }